// extracted by mini-css-extract-plugin
module.exports = {"indicator":"IndicatorResult_indicator_3fNw2"};